var map = {
	"./Brands/hotel_1.jpg": 347,
	"./Brands/hotel_2.jpg": 348,
	"./Brands/hotel_3.jpg": 349,
	"./Brands/hotel_4.jpg": 350,
	"./Brands/hotel_5.jpg": 351,
	"./Brands/hotel_6.jpg": 352,
	"./Brands/hotel_7.jpg": 353,
	"./Flags/France.png": 354,
	"./Flags/Germany.png": 355,
	"./Flags/Italy.png": 356,
	"./Flags/Russia.png": 357,
	"./Flags/Turkey.png": 358,
	"./Flags/United-kingdom.png": 359,
	"./Search/calender.png": 360,
	"./Search/marker.png": 361,
	"./Search/search.png": 362,
	"./Slider/arrow_left.png": 363,
	"./Slider/arrow_right.png": 364,
	"./Slider/slide_1.jpg": 365,
	"./Slider/slide_2.jpg": 366,
	"./Slider/slide_3.jpg": 367,
	"./blog-back.jpg": 368,
	"./blog/b1.jpg": 369,
	"./blog/b2.jpg": 370,
	"./blog/b3.jpg": 371,
	"./blog/b4.jpg": 372,
	"./blog/b5.jpg": 373,
	"./blog/b6.jpg": 374,
	"./credit_cards.png": 375,
	"./europe_tours_1.jpg": 376,
	"./europe_tours_2.jpg": 377,
	"./hotels/details_1.jpg": 378,
	"./hotels/details_10.jpg": 379,
	"./hotels/details_11.jpg": 380,
	"./hotels/details_2.jpg": 381,
	"./hotels/details_3.jpg": 382,
	"./hotels/details_4.jpg": 383,
	"./hotels/details_5.jpg": 384,
	"./hotels/details_6.jpg": 385,
	"./hotels/details_7.jpg": 386,
	"./hotels/details_8.jpg": 387,
	"./hotels/details_9.jpg": 388,
	"./hotels/hotel_1.jpg": 389,
	"./hotels/hotel_2.jpg": 390,
	"./hotels/hotel_3.jpg": 391,
	"./hotels/hotel_4.jpg": 392,
	"./hotels/room_1.png": 393,
	"./hotels/room_2.png": 394,
	"./hotels/room_3.png": 395,
	"./hotels/room_4.png": 396,
	"./hotels/room_5.png": 397,
	"./hotels/room_6.png": 398,
	"./hotels/three_1.jpg": 399,
	"./hotels/three_2.jpg": 400,
	"./hotels/three_3.jpg": 401,
	"./hotels/three_4.jpg": 402,
	"./hotels/three_5.jpg": 403,
	"./hotels/three_6.jpg": 404,
	"./hotels/wide_1.jpg": 405,
	"./hotels/wide_2.jpg": 406,
	"./hotels/wide_3.jpg": 407,
	"./hotels/wide_4.jpg": 408,
	"./main_logo.png": 409,
	"./not-found-logo.jpg": 410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28;